import { RadioGroup, RadioGroupItem } from '@vnetwork/ui/primitives';
import { Field } from '@vnetwork/ui/forms';
import { PLAYOUT_MODES, PLAYOUT_MODE_META, type PlayoutMode } from './playout-modes';

interface PlayoutModeFieldProps {
  value: PlayoutMode;
  onChange: (mode: PlayoutMode) => void;
}

/**
 * Channel playout-mode selector (loop / once / shuffle / epg) with a one-line
 * helper under the picked mode. Shared by the Create and Edit channel dialogs so
 * the option set and copy stay in one place.
 */
export function PlayoutModeField({ value, onChange }: PlayoutModeFieldProps) {
  return (
    <Field label="Playout mode" description={PLAYOUT_MODE_META[value].help}>
      {() => (
        <RadioGroup
          value={value}
          onValueChange={(v) => onChange(v as PlayoutMode)}
          style={{ display: 'flex', gap: 'var(--vn-space-4)', flexWrap: 'wrap' }}
        >
          {PLAYOUT_MODES.map((m) => (
            <label
              key={m}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                fontSize: 'var(--vn-font-size-md)',
              }}
            >
              <RadioGroupItem value={m} /> {PLAYOUT_MODE_META[m].label}
            </label>
          ))}
        </RadioGroup>
      )}
    </Field>
  );
}
